// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "DashboardStatsSummary" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { DateRangeGenShape } from "./date-range.gen";
import { DashboardExportFormatStatsItemGenShape } from "./dashboard-export-format-stats-item.gen";

export const DashboardStatsSummaryGenShape = z.strictObject({
  id: z.string(),
  teamId: z.string(),
  range: DateRangeGenShape,
  name: z.string().optional(),
  docExportsTotal: z.number(),
  docExportsByFormat: z.array(DashboardExportFormatStatsItemGenShape),
});
